export default {
  chartTopOffset: 350,
  minHeight: 230,
};
